import PropTypes from "prop-types"
import React from "react"
import Select from "react-select"
import "react-select/dist/react-select.css"
import "./UnitDropdown.scss"

class UnitDropdown extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedOption: props.units ? props.units[0] : undefined,
    }
  }

  static getDerivedStateFromProps(props, prevState) {
    if (prevState.selectedOption === undefined && props.units) {
      return { selectedOption: props.units[0] }
    } else {
      return null
    }
  }

  handleChange = selectedOption => {
    this.setState({ selectedOption })
    this.props.unitUpdated(selectedOption)
  }

  render() {
    const { selectedOption } = this.state

    return (
      <div className="UnitDropdown">
        <label for="UnitDropdown" className="hidden">
          Unit Dropdown
        </label>
        <Select
          id="UnitDropdown"
          name="UnitDropdown"
          className="UnitDropdown"
          value={selectedOption}
          onChange={this.handleChange}
          options={this.props.units}
          isLoading={this.props.loading}
          clearable={false}
          placeholder="Select a unit..."
        />
      </div>
    )
  }
}

UnitDropdown.propTypes = {
  units: PropTypes.arrayOf(
    PropTypes.shape({ value: PropTypes.string, label: PropTypes.string })
  ),
  unitUpdated: PropTypes.func,
  loading: PropTypes.bool,
}

export default UnitDropdown
